import * as yup from 'yup';
import { takerFieldTypes } from 'containers/app/helpers/takerFieldTypes';
export const takerValidation = fields => {
  // Email regex from: https://emailregex.com/
  // Slightly modified to remove unneeded escaped character
  let schema = {
    email: yup
      .string()
      .strict(false)
      .trim()
      .email('Please enter a valid email')
      .matches(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        'Please enter a valid email'
      )
      .required('Please enter an email')
  };
  fields.forEach(field => {
    let validation;
    const fieldType = field.field_type;
    if (fieldType === takerFieldTypes.select) {
      // Transform the options object to the same format we use to select them
      const options = field.options.map(option => {
        return {
          id: option.id,
          text: option.content[0].text_display
        };
      });
      // We should only allow values that are in the options array to be valid
      validation = yup
        .object()
        .test('Object in options', 'Please select a valid option', data => {
          if (!data) return false;
          return options.some(option => {
            return option.text === data.text;
          });
        });
    } else if (fieldType === takerFieldTypes.text) {
      validation = yup.string();
    }

    field.is_required && (validation = validation.required('Required field'));
    schema = {
      ...schema,
      [field.content[0].title]: validation
    };
  });
  return yup.object().shape(schema);
};
